import {
	Component,
	output,
	ViewChild,
	ElementRef,
	AfterViewInit,
	inject,
	DestroyRef,
} from '@angular/core'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { SearchQuery } from '../../models/search-query.model'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ACTION_PREFIXES } from '../../models/action-prefix.model'

@Component({
	selector: 'lowgile-search-input',
	templateUrl: './search-input.component.html',
	styleUrls: ['./search-input.component.scss'],
	standalone: false,
})
export class SearchInputComponent implements AfterViewInit {
	@ViewChild('input') inputRef: ElementRef<HTMLInputElement>
	queryChange = output<SearchQuery>()

	private searchSubject$ = new Subject<string>()
	private destroyRef = inject(DestroyRef)
	private previousValue = ''

	constructor() {
		this.searchSubject$
			.pipe(
				debounceTime(300),
				distinctUntilChanged(),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((rawQuery) => {
				this.emitQuery(rawQuery)
			})
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.inputRef.nativeElement.focus()
		}, 100)
	}

	onInput(event: InputEvent): void {
		const value = (event.target as HTMLInputElement).value
		const isPrefixOnly = ACTION_PREFIXES.some((p) => p === value)

		if (isPrefixOnly && event.inputType === 'deleteContentBackward') {
			this.clear()
			return
		}

		if (isPrefixOnly) {
			this.inputRef.nativeElement.value = `${value} `
		}

		this.searchSubject$.next(value)
	}

	private emitQuery(rawQuery: string): void {
		const prefixMatch = rawQuery.match(/^([a-zA-Z]+:|[@#>\/])(.*)/)

		if (prefixMatch) {
			this.queryChange.emit({
				rawQuery,
				prefix: prefixMatch[1].replace(':', ''),
				query: prefixMatch[2].trim(),
			})
		} else {
			this.queryChange.emit({
				rawQuery,
				prefix: null,
				query: rawQuery.trim(),
			})
		}
	}

	focus(): void {
		this.inputRef.nativeElement.focus()
	}

	clear(): void {
		this.inputRef.nativeElement.value = ''
		this.searchSubject$.next('')
	}
}
